import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZalamoInlineHelpDirective } from './zalamo-inline-help.directive';
import { InlineHelpContentComponent } from './inline-help-content/inline-help-content.component';
import { EffectsModule } from '@ngrx/effects';
import { ZalamoInlineHelpClientEffects } from './ngrx/zalamo-inline-help-client.effects';
import { StoreModule } from '@ngrx/store';
import {
  reducer,
  zalamoInlineHelpClientFeatureKey,
} from 'ZalamoLibrary/src/lib/ui/zalamo-inline-help/ngrx/zalamo-inline-help-client.reducer';

@NgModule({
  declarations: [ZalamoInlineHelpDirective, InlineHelpContentComponent],
  exports: [ZalamoInlineHelpDirective],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ZalamoInlineHelpClientEffects]),
    StoreModule.forFeature(zalamoInlineHelpClientFeatureKey, reducer),
  ],
})
export class ZalamoInlineHelpModule {}
